import { useDropzone } from 'react-dropzone';
import { ACCEPTED_FILE_TYPES, MAX_FILE_SIZE } from '@/config/constants';
import { useFileUploadHandlers } from './useFileUploadHandlers';
export const useFileDropzone = () => {
    const { onDrop } = useFileUploadHandlers();
    const { open, getInputProps } = useDropzone({
        onDrop,
        accept: ACCEPTED_FILE_TYPES,
        maxSize: MAX_FILE_SIZE,
        noClick: true,
        noKeyboard: true,
    });
    return { open, getInputProps };
};
